// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"289":"6794756a","826":"a7c016b6","893":"3dc29c31"}[chunkId] + ".js";
};